export default [
  {
    path: '/home',
    meta: {
      //keepAlive: true
    },
    component: () => import('Pages/home/index')
  },
  {
    path: '/homePage',
    component: () => import('Pages/home/home-page')
  },
  {
    path: '/dieaseaList',
    component: () => import('Pages/home/dieasea-list')
  },
  {
    path: '/selectHosList',
    component: () => import('Pages/home/select-hos-list')
  },
  {
    path: '/selectHisHosList',
    component: () => import('Pages/home/select-his-hos-list')
  },
  {
    name: 'who-know',
    path: '/who-know',
    component: () => import('Pages/home/who-know')
  },
  {
    path: '/who-know-search',
    component: () => import('Pages/home/who-know-search')
  },
  //更多功能
  {
    path: '/more',
    meta: {
      title: '更多功能'
    },
    component: () => import('Pages/home/more-list'),
    children: [
      {
        path: ':id',
        meta: {
          title: '更多功能'
        },
        component: () => import('Pages/home/more-list-state')
      }
    ]
  },
  {
    path: '/doctor-headlines',
    component: () => import('Pages/home/doctor-headlines')
  }, {
    path: '/information-details/:id',
    component: () => import('Pages/home/information-details')
  }, {
    path: '/knowledge-details/:id',
    props: true,
    component: () => import('Pages/home/knowledge-details')
  },
  {
    path: '/prescribe',
    meta: {
      title: '去开药'
    },
    component: ()=> import('../pages/home/prescribe')
  },
  {
    path: '/selectHos',
    meta: {
      title: '选择医院'
    },
    component: ()=> import('../pages/home/selectHos')
  },
  {
    path: '/bindDocWechat',
    meta: {
      title: '医生绑定'
    },
    component: ()=> import("../pages/bind/bind-doc-wechat")
  },
  {
    path: '/hcrmList',
    component: ()=> import("../pages/home/hcrm-list")
  }
]



// WEBPACK FOOTER //
// ./src/router/home.js